import React from "react";
import moment from "moment";
import { buildScheduledMessageTooltip } from "./scheduled-message-tooltip";

export const scheduledMessageRule = (msg) => {
  const sendDay = Math.abs(Number(msg.send_day));
  const direction = String(msg.reference_direction || "").toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
  const point = String(msg.reference_point || "");
  const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const reference = weekdays.includes(point.toLowerCase())
    ? point.charAt(0).toUpperCase() + point.slice(1)
    : `Check-${point}`;
  if (sendDay === 99999) return "Unscheduled";
  if (sendDay === 99998) return `Email Upon Booking at ${msg.send_time}`;
  const days = sendDay <= 99997 && sendDay >= 99990 ? 99997 - sendDay
    : sendDay <= 99929 && sendDay >= 99900 ? Math.abs(99900 - sendDay) : sendDay;
  return `${days} Day(s) ${direction} ${reference} at ${msg.send_time}`;
};

export const scheduledMessagesForBooking = (messages, reservation) => {
  if (!reservation || reservation.category === "CXL") return [];
  const tagIds = (reservation.tags || reservation.tag_array || []).map((tag) => String(tag.id ?? tag));
  return (messages || []).filter((message) => message.active && !message.deleted &&
    (!(message.tags || []).length || message.tags.some((tag) => tagIds.includes(String(tag.id ?? tag)))))
    .slice().sort((a, b) => String(b.updated_at || "").localeCompare(String(a.updated_at || "")));
};

// Both the Guests column and Messages panel use the same booking-specific rows.
export default function ReservationScheduledMessages({ reservation, messages, sendingMsg, onSend, busy = false, readOnly = false }) {
  const visible = scheduledMessagesForBooking(messages, reservation);
  return <div className="guest-schedule-msg">
    {visible.map((message) => {
      const sent = (reservation.sent_scheduled_messages || [])
        .filter((status) => String(status.msg_id) === String(message.scheduled_message_id) &&
          (!status.guest_reservation_id || String(status.guest_reservation_id) === String(reservation.guest_reservation_id)))
        .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")))[0];
      const rule = sent
        ? `Sent at: ${moment.utc(sent.created_at).local().format("MM/DD/YYYY hh:mm a")}`
        : scheduledMessageRule(message);
      const missingPhone = message.sms && !reservation.phone;
      const missingEmail = message.email && !reservation.email;
      const sending = String(sendingMsg?.reservation_id) === String(reservation.guest_reservation_id) &&
        String(sendingMsg?.msg_id) === String(message.scheduled_message_id);
      const disabled = missingPhone || missingEmail || busy || !!sendingMsg;
      return <div className="uk-flex uk-flex-middle" key={message.scheduled_message_id}>
        <div className="guest-schedule-icon" uk-tooltip={missingPhone ? "Mobile Phone is Missing" : missingEmail ? "Email is Missing" : undefined}>
          <img src={missingPhone || missingEmail ? "/images/missing-phone-email.svg" : sent ? "/images/check.svg" : "/images/send.svg"}
            alt={missingPhone ? "Mobile Phone is Missing" : missingEmail ? "Email is Missing" : sent ? "Sent" : "Not sent"} />
        </div>
        {message.sms && <div className="guest-schedule-icon" uk-tooltip="Text Message"><img src="/images/text-tag.svg" alt="Text Message" /></div>}
        {message.email && <div className="guest-schedule-icon" uk-tooltip="Email Message"><img src="/images/email-tag.svg" alt="Email Message" /></div>}
        {readOnly ? <span uk-tooltip={buildScheduledMessageTooltip(message.name, rule)}>
          {sent ? "Sent " : ""}{message.name}
        </span> : <button type="button" className={`hms-sms-send-text scheduled-message-action${disabled ? " disabled" : ""}`}
          disabled={disabled} uk-tooltip={buildScheduledMessageTooltip(message.name, rule)}
          aria-label={`${sending ? "Sending" : sent ? "Resend" : "Send"} ${message.name}: ${rule}`}
          onClick={() => onSend(reservation.guest_reservation_id, message.scheduled_message_id)}>
          {sending ? "Sending " : sent ? "Resend " : "Send "}{message.name}{sending ? "..." : ""}
        </button>}
      </div>;
    })}
  </div>;
}
